<template>
  <div>
    <div class="otsMainTitle">
      <!-- <div class="title-l">{{pageTitle}}</div> -->
      <el-breadcrumb separator="/">
        <el-breadcrumb-item
          v-for="item in breadList"
          :key="item.path"
          :to="{ path: item.path}"
          :class="item.name === $route.name ? 'currentBread' : 'otherBread'"
          >{{ item.meta.title }}</el-breadcrumb-item
        >
      </el-breadcrumb>
      <div>
        <slot name="tabs"></slot>
      </div>
      <div class="title-r">
        <el-input
          v-if="mainSearch"
          class="search input-with-select"
          v-model="inputValue"
          placeholder="请输入搜索关键字"
        >
        </el-input>
        <div class="iconfont icon-sousuo inputSearch" @click="handleSearch" v-if="isShowSearchIcon">
          <i class="f14"></i>
        </div>
        <div v-for="item in mainTopBtn" :key="item.title" v-show="!item.notShow">
          <el-dropdown v-if="item.select">
            <span class="el-dropdown-link">
              <el-button
                :type="item.type || 'primary'"
                :plain="item.plain || false"
                :disabled="item.disabled || false"
                round
                >{{ item.title }}</el-button
              >
            </span>
            <template v-if="item.children">
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(itemChild, index) in item.children"
                  :key="index"
                  v-show="!itemChild.notShow"
                >
                  <div @click="itemChild.fn">{{ itemChild.title }}</div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <el-button
            v-else
            :type="item.type || 'primary'"
            :plain="item.plain || false"
            :disabled="item.disabled || false"
            @click="item.fn"
            round
            >{{ item.title }}</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "OtsMainTitle",
  props: {
    mainTopBtn: {
      type: Array,
      default: () => {},
    },
    mainSearch: {
      type: Boolean,
      default: false,
    },
    isShowSearchIcon: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      inputValue: "",
      oldInputValue: "",
      breadList: [],
    };
  },
  methods: {
    handleSearch() {
      if (this.inputValue == this.oldInputValue) {
        return;
      }
      this.oldInputValue = this.inputValue;
      this.$emit("searchFn", this.oldInputValue);
    },
    hideSearchIcon() {
      this.isShowSearchIcon = false
    }
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        this.breadList = this.$route.matched.filter((item) => {
          return item.name
        });
      },
      // 深度观察监听
      deep: true,
      immediate: true,
    },
  },
};

</script>

<style lang="less" scoped>
.otsMainTitle {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  line-height: 40px;
  margin-bottom: 24px;
  .currentBread {
    font-size: 24px;
    font-weight: 500;
    color: #2d2f33;
  }
  /deep/ .otherBread {
    color: #9299a6;
  }
  .title-r {
    display: flex;
    position: relative;
    .inputSearch {
      display: none;
      position: absolute;
      left: 895px;
      top: 10px;
      height: 22px;
      line-height: 22px;
      cursor: pointer;
      color: #ced2d9;
      padding: 0 10px;
      border-left: 1px solid #dcdfe6;
    }
  }
}
.title-r /deep/ .el-input__inner {
  background: #ffffff;
  width: 380px;
  height: 40px;
  border-radius: 40px;
  padding-right: 50px !important;
}
.el-breadcrumb {
  display: flex;
  align-items: flex-end;
}
.otherBread /deep/.el-breadcrumb__inner.is-link {
  color: #9299a6;
  font-weight: 400;
}
.el-button--primary {
  background: #006aff;
  border-color: #006aff;
  margin-left: 16px;
}
.el-button--primary:focus,
.el-button--primary:hover {
  background: #006aff;
  border-color: #006aff;
  color: #fff;
}
.el-button--primary.is-plain {
  color: #006aff;
  background: #ecf5ff;
  border-color: #b3d8ff;
}
.otherBread /deep/.el-breadcrumb__inner.is-link:hover {
  color: #006aff;
  cursor: pointer;
}
.el-button.is-plain:focus,
.el-button.is-plain:hover {
  background: #ecf5ff;
  border-color: #409efd;
  color: #006aff;
}
/deep/ .el-breadcrumb__item:last-child .el-breadcrumb__inner,
/deep/ .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
/deep/ .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
/deep/ .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 500;
  color: #2d2f33;
  cursor: text;
}

</style>